import { subDays, startOfDay } from "date-fns";


type SearchTransactionDto = {
    customerId: string;
    page: number;
    searchTerm?: string;
    startDate?: Date;
    endDate?: Date;
    sortDirection?: string | null;
}

export const getInitialSearchDto = (customerId: string) => {
    const endDate = startOfDay(new Date());
    const startDate = new Date(subDays(endDate, 90));
    return {
        customerId: customerId,
        startDate: startDate,
        endDate: endDate,
        searchTerm: "",
        page: 0,
        sortDirection: "desc"
    };
}

export default SearchTransactionDto;